import { render, staticRenderFns } from "./column2.vue?vue&type=template&id=428a2e24&scoped=true&"
import script from "./column2.vue?vue&type=script&lang=js&"
export * from "./column2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a2e24",
  null
  
)

component.options.__file = "column2.vue"
export default component.exports